// extracted by mini-css-extract-plugin
export default {"container":"Arrivi_container__dc65e","event_flex":"Arrivi_event_flex__10Lz1","event_title_flex":"Arrivi_event_title_flex__ECtsf"};